import { RouteName } from '@mews-commander/enums';
import { ContentCard } from '@mews-commander/ui';
import { useResolveRoute } from '@mews/routing';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import TemplateFetcher from '../../../../app/components/TemplateFetcher';

interface ActionLogProps {
    companyId: string;
}

export const ActionLogTab = ({ companyId }: ActionLogProps) => {
    const enterpriseId = useCurrentEnterpriseId();
    const resolveRoute = useResolveRoute();
    const url = resolveRoute(RouteName.CompanyActionLog, { id: companyId, query: { EnterpriseId: enterpriseId } });

    return (
        <ContentCard>
            <TemplateFetcher url={url} layout="Empty" />
        </ContentCard>
    );
};
